import React from 'react';
// envelope
export default ({ className, ...other }) => (
  <svg

    className={`icon w-branding ${className || ''}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17.438 19"
  >
    <g
      id="Grupo_615"
      data-name="Grupo 615"
      transform="translate(-1399.5 -1596.5)"
    >
      <g id="Grupo_604" data-name="Grupo 604" transform="translate(0 -0.88)">
        <path
          id="Trazado_1138"
          data-name="Trazado 1138"
          d="M1148.993,1691.279h16.438"
          transform="translate(251.007 -91.279)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Trazado_1141"
          data-name="Trazado 1141"
          d="M1148.993,1691.385h4"
          transform="translate(3094.604 448.887) rotate(90)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
      <g id="Grupo_603" data-name="Grupo 603" transform="translate(0 -0.5)">
        <path
          id="Trazado_1140"
          data-name="Trazado 1140"
          d="M1148.993,1691.279h16.438"
          transform="translate(251.007 -84.779)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Trazado_1142"
          data-name="Trazado 1142"
          d="M1148.993,1691.385h4"
          transform="translate(3103.604 455.507) rotate(90)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
      <g id="Grupo_602" data-name="Grupo 602" transform="translate(0 0.5)">
        <path
          id="Trazado_1139"
          data-name="Trazado 1139"
          d="M1148.993,1691.279h16.438"
          transform="translate(251.007 -78.779)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Trazado_1143"
          data-name="Trazado 1143"
          d="M1148.993,1691.385h4"
          transform="translate(3098.604 461.507) rotate(90)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
);
